import { FC, ReactElement } from 'react';
import { Checkbox } from '@ebsco-ui/ebsco-ui';

import { ShapeWithClassName } from '@app/constants';

import { FieldWrapper } from './FieldWrapper';
import { FieldProps } from './constants';

export const CheckboxField: FC<ShapeWithClassName<FieldProps>> = (
  props
): ReactElement => <FieldWrapper component={Checkbox} {...props} />;
